import React, { useState, ReactNode } from 'react';
import Header from '../components/Header/index';
import Sidebar from '../components/Sidebar/index';

const DefaultLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [afiliadosOpen, setAfiliadosOpen] = useState(true);
  const [creditosOpen, setCreditosOpen] = useState(true);

  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark">
      {/* <!-- ===== Page Wrapper Start ===== --> */}
      <div className="flex h-screen overflow-hidden">
        {/* <!-- ===== Sidebar Start ===== --> */}
              <Sidebar
                  sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}
                  afiliadosOpen={afiliadosOpen} setAfiliadosOpen={setAfiliadosOpen}
                  creditosOpen={creditosOpen} setCreditosOpen={setCreditosOpen}
              />
        {/* <!-- ===== Sidebar End ===== --> */}

        {/* <!-- ===== Content Area Start ===== --> */}
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          {/* <!-- ===== Header Start ===== --> */}
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          {/* <!-- ===== Header End ===== --> */}

          {/* <!-- ===== Main Content Start ===== --> */}
          <main>
            {/*  <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">*/}
                      <div className="mx-auto p-4 bg-gray-2 dark:bg-graydark min-h-screen">
                  {children}
            </div>
          </main>
          {/* <!-- ===== Main Content End ===== --> */}
        </div>
        {/* <!-- ===== Content Area End ===== --> */}
      </div>
      {/* <!-- ===== Page Wrapper End ===== --> */}
    </div>
  );
};

export default DefaultLayout;
